/*
 * Copyright Robert Bosch GmbH. Copyright Robert Bosch GmbH. All rights reserved, also regarding any disposal, exploration, reproduction, editing, distribution, as well as in the event of applications for industrial property rights.
 */
module.exports = {
  UPDATE_AUTH: 'UPDATE_AUTH',
  UPDATE_MODAL: 'UPDATE_MODAL',
  UPDATE_BREADCRUMBS: 'UPDATE_BREADCRUMBS',
  UPDATE_TOASTER_CONFIG: 'UPDATE_TOASTER_CONFIG',
  UPDATE_FILTER_DATA: 'UPDATE_FILTER_DATA',
  UPDATE_APPLIED_FILTER_DATA: 'UPDATE_APPLIED_FILTER_DATA',
};
